import React from 'react';
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";

import { phoneRegex } from '../../utils/Regex';
import { createAdmin } from '../../services/super-admin.service';
import { createProject } from '../../services/Project.service';
import BackIcon from '../../assets/images/back_icon.svg'
import CreateIcon from '../../assets/images/create_icon.svg'

import ArrowleftIcon from "../../assets/images/arrowleft_icon.svg";
import { projectTypes } from "../../global/transactionTypes"

// const projectTypes = [
//     { key: "2", value: "GLOBAL" },
//     { key: "0", value: "NON-OFFICE" },
//     { key: "1", value: "OFFICE" },

//   ];
const MakeTransaction = ({ back }) => {
    
    const handleClose = () => {

        resetForm();
        setErrors({});
        back(false)
    }

    // form 

    const { handleBlur, handleChange, handleSubmit, values, errors, touched, resetForm, setErrors } = useFormik({
        initialValues: {
            name: "",
            typeId:""
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .max(50, "Project Name must be at most 50 characters")
                .required("Project Name is required"),
                typeId: Yup.string().required("Type is required"),
        }),
        onSubmit: async (values, { resetForm }) => {
            try {

                const payload = {
                    "id":"9",
                    "name": values.name,
                    "description": values.name,
                    "project":values.name,
                    "type": Number(values.typeId),
                    "status": 1,
                    "active": true,
                    "createdDate": "",
                    "startDate": "",
                    "endDate": "",
                    "transactions":null,
                    "projectValue": values.projectValue,
                    "expenseValue": values.expenseValue
                  }

                const res = await createProject(payload)

                if (res?.status === 201) {
                    toast.success("Project Successfully Added")
                    resetForm();
                    setErrors({});
                    back()

                } else {
                    toast.error("Not Added");
                }
            } catch (error) {
                if (error?.message) {
                    const msg = error?.message?.split(":")?.[1]?.trim();
                    console.error(msg)


                }
                console.log(error.message);
            }
        },
    });

    return (
        <div className='whiteFrame'>
            <div className="mb_24 displayFlex alignItem_center gap12">
                <div>
                    <button
                        className="emptyBtn"
                        type="button"
                        onClick={handleClose}
                    >
                        <img src={ArrowleftIcon} alt="ArrowleftIcon" />
                    </button>

                </div>
                <div>
                    <h5 className='fontSize20 fontWeight600 blackClr_text'> Add Project</h5>
                </div>
               
            </div>




            <form onSubmit={handleSubmit}>
                <div className='row'> 
                <div className="mb_24 col-md-6">
                    <label
                        className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                        htmlFor="name"
                    >
                        Project Name                    </label>
                    <input
                        className="MainInput"
                        type="text"
                        placeholder="Enter Project Name"
                        id="name"
                        name="name"
                        value={values.name}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    {errors.name && touched.name ? (
                        <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                            {errors.name}
                        </p>
                    ) : (
                        <></>
                    )}
                </div>
                <div className="mb_24 col-md-6">
                    <label
                        className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                        htmlFor="name"
                    >
                        Project value                    </label>
                    <input
                        className="MainInput"
                        type="text"
                        placeholder="Enter Project Value"
                        id="projectValue"
                        name="projectValue"
                        value={values.projectValue}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    {errors.name && touched.name ? (
                        <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                            {errors.name}
                        </p>
                    ) : (
                        <></>
                    )}
                </div> <div className="mb_24 col-md-6">
                    <label
                        className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                        htmlFor="name"
                    >
                        Expense value in %                    </label>
                    <input
                        className="MainInput"
                        type="text"
                        placeholder="Enter Project Expenses in %"
                        id="expenseValue"
                        name="expenseValue"
                        value={values.expenseValue}
                        onBlur={handleBlur}
                        onChange={handleChange}
                    />
                    {errors.name && touched.name ? (
                        <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                            {errors.name}
                        </p>
                    ) : (
                        <></>
                    )}
                </div>

                <div className="mb_24 col-md-6">
              <label
                className="fontSize14 fontWeight500 blackClr_text display_block mb_8"
                htmlFor="typeId"
              >
                Type
              </label>
              <select
                className="selectMainInput"
                id="typeId"
                name="typeId"
                value={values.typeId}
                onChange={handleChange}
              >
                <option value="">Select Type</option>
                {projectTypes.map((count) => (
                <option key={count.key} value={count.key}>
                  {count.value}
                </option>
              ))}
              </select>
              {errors.typeId && touched.typeId ? (
                <p className="fontSize12 fontWeight500 errorClr_text mt_8">
                  {errors.typeId}
                </p>
              ) : (
                <></>
              )}
            </div>

                </div>
                {/* ========= Submit Button ========= */}
                {/* <div className='justifyContent_end displayFlex'>
                    <div> */}
                        <button type="submit" className="MainButton cyanSky_clr gap8">
                            <img className='width20px' src={CreateIcon} alt="CreateIcon" />
                            <span>Create Project</span>
                        </button>
                    {/* </div>
                </div> */}
            </form>





        </div>
    )
}

export default MakeTransaction